import { CustomError, OpportunitySearchResults } from "@skv/core";
import { SearchResultStatus } from "@skv/core/src/types";

export interface State {
  loading: boolean;
  error: false | null | CustomError;
  data: { [searchQuery: string]: OpportunitySearchResults };
  state: SearchResultStatus;
}

export type ActionTypes =
  | {
      type: "RESULT:FETCH:START";
    }
  | {
      type: "RESULT:FETCH:END" | "RESULT:FETCH:END:CACHE";
      payload: {
        searchQuery: string;
        data: OpportunitySearchResults;
      };
    }
  | {
      type: "RESULT:FETCH:ERROR";
      payload: {
        error: CustomError;
      };
    }
  | {
      type: "RESULT:ERROR:RESET";
    };

export const reducer = (
  state: State = {
    loading: false,
    error: false,
    data: {},
    state: SearchResultStatus.IDLE,
  },
  action: ActionTypes
): State => {
  switch (action.type) {
    case "RESULT:FETCH:START":
      return {
        ...state,
        loading: true,
        error: false,
        state: SearchResultStatus.FETCHING_DATA,
      };
    case "RESULT:FETCH:END":
    case "RESULT:FETCH:END:CACHE":
      return {
        ...state,
        loading: false,
        error: false,
        data: {
          ...state.data,
          [action.payload.searchQuery]: action.payload.data,
        },
        state: SearchResultStatus.IDLE,
      };
    case "RESULT:FETCH:ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        state: SearchResultStatus.FETCH_ERROR,
      };
    case "RESULT:ERROR:RESET":
      return {
        ...state,
        loading: false,
        error: false,
        state: SearchResultStatus.IDLE,
      };
    default:
      return state;
  }
};
